import { Box, Typography } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import { useContext, useEffect, useMemo, useState } from 'react';

import PortalClosedBanner from '@/components/application_components/PortalClosedBanner';
import { CurrentApplicationContext } from '@/Contexts/CurrentApplicationContext';
import { SelectedProgramContext } from '@/Contexts/SelectedProgramContext';
import { ApplicationTypes } from '@/models/ApplicationType';

import treeCityUSA from '../../assets/logo-tree-city-usa.svg';
import { LocaleContext } from '@/Contexts/LocaleContext';

interface Props {
  name: string | null;
}

function GrowthHeader({ name }: Props) {
  const [open, setOpen] = useState<boolean>(false);
  const { portalOpen } = useContext(SelectedProgramContext);
  const { canEdit, partnerInfo } = useContext(CurrentApplicationContext);
  const { translatedText } = useContext(LocaleContext);
  const [title, setTitle] = useState<string | null>('');

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    const t = name != null ? name : partnerInfo?.partnerName;
    setTitle(t ?? '');
  }, [name, partnerInfo?.partnerName]);

  const programImage = useMemo(() => ProgramImage(), []);

  return (
    <Box
      display='flex'
      height='min-content'
      padding={1.25}
      flexDirection='column'
      alignItems='center'
      justifyContent='center'
    >
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}
        message={translatedText.applicationHeader.messageRequiredQuestions}
      />
      <Box
        display='flex'
        flexDirection='column'
        alignItems='center'
        justifyContent='center'
        gap='15px'
      >
        {programImage}
        <Typography variant='h1'>{title != null ? title : 'ADDITIONAL QUESTIONS'}</Typography>
      </Box>
      {!portalOpen[ApplicationTypes.GrowthAward] && !canEdit && (
        <PortalClosedBanner applicationTypeId={ApplicationTypes.GrowthAward} />
      )}
    </Box>
  );

  function ProgramImage() {
    return <img alt='Tree City USA Logo' style={{ height: '70px' }} src={treeCityUSA} />;
  }
}

export default GrowthHeader;
